const APP_DEFAULT_PATH = '/dashboard/analytics';
const HORIZONTAL_MAX_ITEM = 7;
const DRAWER_WIDTH = 260;
const MINI_DRAWER_WIDTH = 60;

const MobileConfig = {
  APP_DEFAULT_PATH,
  HORIZONTAL_MAX_ITEM,
  DRAWER_WIDTH,
  MINI_DRAWER_WIDTH,
};
export default MobileConfig;
